import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { capitalisePostTown } from "capitalise-post-town";
import { update } from "./input";
import { toElem, contains } from "./dom";
import { updateCountry } from "./country";
import { isGbrAddress } from "./types";
import { isString } from "./string";
import { cssEscape } from "./util";
export var updateAddressLines = function updateAddressLines(targets, address) {
  var _toAddressLines = toAddressLines(numberOfLines(targets), address),
      _toAddressLines2 = _slicedToArray(_toAddressLines, 3),
      line_1 = _toAddressLines2[0],
      line_2 = _toAddressLines2[1],
      line_3 = _toAddressLines2[2];

  update(targets.line_1, line_1, true);
  update(targets.line_2, line_2);
  update(targets.line_3, line_3);
};
export var addressRetrieval = function addressRetrieval(_ref) {
  var targets = _ref.targets,
      config = _ref.config;
  return function (address) {
    updateAddressLines(targets, address);
    update(targets.post_town, address.post_town);
    update(targets.postcode, address.postcode);
    updateCountry(targets.country, address);
    if (config.populateOrganisation) update(targets.organisation, address.organisation_name);
    if (config.populateCounty) update(targets.county, address.county);
  };
};
export var numberOfLines = function numberOfLines(targets) {
  var line_2 = targets.line_2,
      line_3 = targets.line_3;
  if (!line_2) return 1;
  if (!line_3) return 2;
  return 3;
};
export var join = function join(list) {
  return list.filter(function (e) {
    if (isString(e)) return !!e.trim();
    return !!e;
  }).join(", ");
};
export var toAddressLines = function toAddressLines(n, address) {
  var line_1 = address.line_1,
      line_2 = address.line_2;
  var line_3 = "line_3" in address ? address.line_3 : "";
  if (n === 3) return [line_1, line_2, line_3];
  if (n === 2) return [line_1, join([line_2, line_3]), ""];
  return [join([line_1, line_2, line_3]), "", ""];
};
export var extract = function extract(a, attr) {
  var result = a[attr];
  if (typeof result === "number") return result.toString();
  if (result === undefined) return "";
  return result;
};
export var getFields = function getFields(o) {
  return _objectSpread(_objectSpread(_objectSpread({}, o.outputFields), searchNames(o.names || {}, o.config.scope)), searchLabels(o.labels || {}, o.config.scope));
};

var updateLines = function updateLines(fields, address, scope) {
  var _toAddressLines3 = toAddressLines(numberOfLines(fields), address),
      _toAddressLines4 = _slicedToArray(_toAddressLines3, 3),
      line_1 = _toAddressLines4[0],
      line_2 = _toAddressLines4[1],
      line_3 = _toAddressLines4[2];

  update(toElem(fields.line_1 || null, scope), line_1);
  update(toElem(fields.line_2 || null, scope), line_2);
  update(toElem(fields.line_3 || null, scope), line_3);
};

export var searchNames = function searchNames(names, scope) {
  var result = {};
  var key;

  for (key in names) {
    if (!names.hasOwnProperty(key)) continue;
    var name = names[key];
    var named = toElem("[name=\"".concat(name, "\"]"), scope);

    if (named) {
      result[key] = named;
      continue;
    }

    var ariaNamed = toElem("[aria-name=\"".concat(name, "\"]"), scope);
    if (ariaNamed) result[key] = ariaNamed;
  }

  return result;
};
export var searchLabels = function searchLabels(labels, scope) {
  var result = {};
  if (labels === undefined) return labels;
  var key;

  for (key in labels) {
    if (!labels.hasOwnProperty(key)) continue;
    var name = labels[key];
    if (!name) continue;
    var first = contains(scope, "label", name);
    var label = toElem(first, scope);
    if (!label) continue;
    var forEl = label.getAttribute("for");

    if (forEl) {
      var byId = scope.querySelector("#".concat(cssEscape(forEl)));

      if (byId) {
        result[key] = byId;
        continue;
      }
    }

    var inner = label.querySelector("input");
    if (inner) result[key] = inner;
  }

  return result;
};
export var populateAddress = function populateAddress(options) {
  var config = options.config;

  var address = _objectSpread({}, options.address);

  var scope = config.scope,
      titleizePostTown = config.titleizePostTown,
      populateOrganisation = config.populateOrganisation,
      populateCounty = config.populateCounty;
  var fields = getFields(options);

  if (isGbrAddress(address)) {
    if (config.removeOrganisation) removeOrganisation(address);

    if ("post_town" in address && titleizePostTown) {
      address.post_town = capitalisePostTown(address.post_town);
    }

    if (populateOrganisation === false) delete address.organisation_name;
    if (populateCounty === false) delete address.county;
  }

  updateLines(fields, address, scope);
  delete address.line_1;
  delete address.line_2;
  delete address.line_3;
  updateCountry(toElem(fields.country || null, scope), address);
  delete address.country;
  var e;

  for (e in fields) {
    if (address[e] === undefined) continue;

    if (fields.hasOwnProperty(e)) {
      var value = fields[e];
      if (!value) continue;
      update(toElem(value, scope), extract(address, e));
    }
  }
};
export var removeOrganisation = function removeOrganisation(address) {
  if (address.organisation_name.length === 0) return address;
  if (address.line_2.length === 0 && address.line_3.length === 0) return address;

  if (address.line_1 === address.organisation_name) {
    address.line_1 = address.line_2;
    address.line_2 = address.line_3;
    address.line_3 = "";
  }

  return address;
};